(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v-bts-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-community')) {
    customElements.define(
      'v-bts-community',
      class VBtsCommunity extends HTMLElement {
        connectedCallback() {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-bts-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-hero')) {
    customElements.define(
      'v-bts-hero',
      class VBtsHero extends HTMLElement {
        connectedCallback() {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-bts-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-story')) {
    customElements.define(
      'v-bts-story',
      class VBtsStory extends HTMLElement {
        connectedCallback() {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-pdp-tech"] && !Shopify.designMode) return;
  try {
    
  class VPdpTech extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _setOpen(item) {
      this.querySelectorAll('[data-tech-item]').forEach((el) => {
        const isMatch = el === item;
        el.classList.toggle('is-open', isMatch);
        const trigger = el.querySelector('[data-action="toggle-item"]');
        if (trigger) trigger.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
      });
    }

    _onClick(event) {
      const trigger = event.target.closest('[data-action="toggle-item"]');
      if (!trigger || !this.contains(trigger)) return;
      const item = trigger.closest('[data-tech-item]');
      if (!item) return;
      if (item.classList.contains('is-open')) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      this._setOpen(item);
    }

    _onBlockSelect(event) {
      const item = event.target.closest('[data-tech-item]');
      if (item) this._setOpen(item);
    }
  }

  if (!customElements.get('v-pdp-tech')) {
    customElements.define('v-pdp-tech', VPdpTech);
  }

  } catch(e) { console.error(e); }
})();
})();
